/**
 * Helpers for adding special event handlers.
 *
 * @module
 */

import { up } from './QuerySelectors.js';

/**
 * Analog of jQuery's delegated event handlers, which run through event propagation.
 *
 * @param {string} eventType
 * @param {string} selector CSS selector which must match the event target or one of its descendants up to the delegator.
 * @param {Function} fn
 * @param {HTMLElement} [delegator] Element under which the event must be contained.
 */
export function onDelegatedEvent(eventType, selector, fn, delegator = document.documentElement) {
    return delegator.addEventListener(eventType, function(e) {
        if (e.target.matches(selector)) {
            return fn(e, e.target);
        }
        const match = up(e.target, selector, delegator);
        if (match) {
            return fn(e, match);
        }
    });
}
